import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=dad25542&"
import script from "./FormSelect.vue?vue&type=script&lang=js&"
export * from "./FormSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=dad25542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
